<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
  color: {
    type: String,
    default: "#6C737F",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
